import React, { useState, useEffect, useRef } from 'react';
import types from 'prop-types';
import './MediaLib.css';


MediaLib.propTypes = {
  cnf: types.object,
  ver: types.object
};
const params = (new URL(document.location)).searchParams

export  function MediaLib(props) {
  const mlw = useRef(null);
  let assetType = useRef('image');
  const validators = [];
  const sizeLimit = useRef(50);
  const [errors, setErrors] = useState([]);
  const token = params.get('token');
  const origin = params.get('origin');


  function TooBigMsg() {
    return (<span>This {assetType.current} exceeds the maximum file size that can be modified directly in the content block. To increase this limit, see <a target={'_blank'} rel={'noopener noreferrer'} href="https://cloudinary.com/documentation/salesforce_marketing_cloud_app_integration">documentation</a></span>);
  }

  useEffect(() => {
   function buildMlw() {
      let conf = {
        access_token: token,
        remove_header: true,
        inline_container: 'div.ml',
        multiple: true,
        sandboxAttributes: ['allow-scripts', 'allow-same-origin'],
        integration: {
          type: 'sfmc_cartridge',
          platform: 'salesforce_marketing_cloud',
          version: 'dev',
          environment: 'dev'
        }
      };
      // eslint-disable-next-line no-undef
      mlw.current = cloudinary.createMediaLibrary(conf, {
        insertHandler: async (data) => {
          const errorTexts = {
            'tooBig': <TooBigMsg />,
            'wrongType': `Only ${assetType.current}s can be inserted into this content block`,
            'restricted': 'This asset is restricted',
            'noDimensions': `Something seems to be wrong with this ${assetType.current}`
          };
          // let asset = data.assets;
          let errorBanners = [];
          let assets = data.assets

          for (const asset of assets) {
            const args = { asset: asset, sizeLimit: sizeLimit.current, rightType: assetType.current};
            const validatorsRes = await Promise.allSettled(validators.map((v) => v(args)));
            validatorsRes.forEach((res) => {
              if (res.status === 'rejected') {
                // errorBanners.push(<Banner type={'error'} content={errorTexts[res.reason]} key={res.reason} click={() => removeError(res.reason)}/>);
              }
            });
          }
          setErrors(errorBanners);
          if (errorBanners.length === 0) {
            let message = {
              assets: assets,
              messageType: 'assets'
            }
            window.opener.postMessage(message, origin);
            window.close();
          }
        }
      });
       mlw.current.show()
    }
    const script = document.createElement('script');
    script.async = true;
    script.id = 'mlw';
    document.body.appendChild(script);
    script.onload = buildMlw;
    script.src = process.env.REACT_APP_MLW_URL || 'https://media-library.cloudinary.com/global/all.js';
    return () => {
      document.body.removeChild(script);
    };
  }, [validators]);

  return (
      <React.Fragment>
        <div className="ml" />
      </React.Fragment>
  );
}
